import React, { useEffect, useState } from 'react';
import api from '../../../api';
import styles from './AdViseStep1.module.css';

const AdViseStep1 = ({ setAdViseStep, stepProps, setStepProps, marginTop }) => {
  const [regionStats, setRegionStats] = useState({});

  // 화면 진입 시 한번만 API 호출
  useEffect(() => {
    // STEP props 초기화(생략)...

    api.get('/advise/admin/region-stats')
      .then(({ data }) => {
        setRegionStats(data);
      })
      .catch(err => {
        console.error('Error fetching upload-days:', err);
      });
  }, []);

  // 사용자가 지역을 선택했을 때
  const whenRegionSelected = region => {
    setStepProps(prev => {
      const next = [...prev];
      next[1] = region;
      return next;
    });
    setAdViseStep(2);
  };

  // "오늘"/"x일 전"/"-" 텍스트 결정
  const renderSubText = region => {
    const days = regionStats[region]?.days_since_upload;
    if (days == null) return '-';
    if (days === 0)  return '오늘';
    return `${days}일 전`;
  };

  const renderPoolPendingText = region => {
    const pool = regionStats[region]?.hotple_pool_count || 0;
    const pending = regionStats[region]?.pending_advise_count || 0;
    return `${pending} | ${pool}`;
  };

  return (
    <div className={styles.outerframe}>
      <div className={styles.upperframe}>
        <img
          className={styles.backbuttonIcon}
          alt=""
          src="images/back_android.svg"
          onClick={() => setAdViseStep(0)}
        />
        <div className={styles.titleframe}>
          <b className={styles.buttontitle}>STEP 1</b>
          <div className={styles.stepdesc}>
            어떤 계정의 콘텐츠를 제작할까요?
          </div>
        </div>
        <img
          className={styles.homebuttonIcon}
          alt=""
          src="images/home_outlined.svg"
          onClick={() => setAdViseStep(0)}
        />
      </div>

      <div
        className={styles.lowerframe}
        style={{ height: `calc(100dvh - ${marginTop}px)` }}
      >
        <div className={styles.contentframe}>

          <div className={styles.buttonrowframe}>
            {['서울','경기'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <div className={styles.buttonrowframe1}>
            {['인천','대전','강원'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <div className={styles.buttonrowframe1}>
            {['충북','충남','세종'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <hr style={{width: "100%", height:'1px', border:'none', backgroundColor: "#cdcdcd"}}/>

          <div className={styles.buttonrowframe1}>
            {['부산','대구','울산'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <div className={styles.buttonrowframe1}>
            {['경북','경남','제주'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <div className={styles.buttonrowframe1}>
            {['광주','전북','전남'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>

          <hr style={{width: "100%", height:'1px', border:'none', backgroundColor: "#cdcdcd"}}/>

          <div className={styles.buttonrowframe1}>
            {['공식','전지역','테스트'].map(region => (
              <div
                key={region}
                className={
                  regionStats[region]?.days_since_upload === 0
                    ? styles.buttonframe1
                    : styles.buttonframe4
                }
                onClick={() => whenRegionSelected(region)}
              >
                <b className={styles.buttontitle1}>{region}</b>
                <div className={styles.buttonsub}>{renderPoolPendingText(region)}</div>
                <div className={styles.buttonsub4}>{renderSubText(region)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdViseStep1;
